import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'app-info-campaign',
  templateUrl: './info-campaign.component.html',
  styleUrls: ['./info-campaign.component.scss']
})
export class InfoCampaignComponent implements OnInit {
  pcForm!: FormGroup;
  campaigns: any[] = [];
  @Output() dataChange = new EventEmitter<any>();
  @Output() disable = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.getCampaign();
    this.initializeForm();
    
    // Subscribe to form changes
    this.pcForm.valueChanges.subscribe((formData) => {
      // console.log('valueChanges',formData);

      // ตรวจว่า batchCode ที่กรอกกับ batchCode ในระบบ ความยาวตรงกัน ถูกต้อง
      let batchCodePass = false;
      if(formData.campaignBatchCode) {
        if(formData.batchCode.length == formData.bc.length) {
          batchCodePass = true;
        }
      }

      var result = {
        campaign: formData.campaign,
        campaignBatchCode: formData.campaignBatchCode,
        assistantPc: formData.assistantPc,
        batchCodePass: batchCodePass,
        batchCode: formData.batchCode,
        imageUrl: formData.imageUrl
      };
      // console.log('result campaign :: ',result);
      this.dataChange.emit(result);
      this.disable.emit(this.checkDisable());
    });
  }

  initializeForm(): void {
    this.pcForm = this.fb.group({
      campaign: ['', [Validators.required]],
      campaignBatchCode: [false],
      assistantPc: ['', [Validators.required]],
      batchCode: [''],
      bc: [''],
      imageUrl: [null],
    });
  }
  
  get f() {
    return this.pcForm.controls;
  }

  async getCampaign() {
    this.userService.getCampaigns({}).subscribe({
      next: (res) => {
        this.campaigns = res;
      },
      error: (error) => null,
    });
  }

  changeCampaign(event: any) {
    console.log(event.target.value);
    // campaignAndClinic ไม่มี s 
    var cam = this.campaigns.find((c: any) => c.id == event.target.value);
    var batch = cam.campaignAndClinic[0].batchCode??'';
    if (batch) {
      this.pcForm.get('batchCode')?.setValidators([Validators.required]);
      this.pcForm.get('imageUrl')?.setValidators([Validators.required]);
    } else {
      this.pcForm.get('batchCode')?.clearValidators();
      this.pcForm.get('imageUrl')?.clearValidators();
    }
    this.pcForm.get('batchCode')?.updateValueAndValidity();
    this.pcForm.get('imageUrl')?.updateValueAndValidity();
    this.pcForm.patchValue({
      campaignBatchCode: batch != '' ? true : false,
      bc: batch,
    });
  }

  // Handle the emitted image file from the child component
  onImageSelected(image: String): void {
    // this.articleForm.get('image')?.setValue(file);
    this.f['imageUrl'].setValue(image);
  }

  checkDisable() {
    if (this.pcForm.valid) {
      return false;
    } else {
      return true;
    }
  }
}
